import { Route, Switch } from "react-router-dom";

import BrandPageTopReorderedNuxPage from "@faire/prototype-playground/workspace/wc/brand-page-top-reordered-nux";
import ExpandedCollectionsPage from "@faire/prototype-playground/workspace/wc/expanded-collections";
import MiniPdpModalsPage from "@faire/prototype-playground/workspace/wc/mini-pdp-modals";
import PdpMaskSafetyDisclaimerPage from "@faire/prototype-playground/workspace/wc/pdp-mask-safety-disclaimer";

export function WillChartrandRoutes() {
  return (
    <Switch>
      <Route
        path="/wc/brand-page-top-reordered-nux"
        component={BrandPageTopReorderedNuxPage}
      />
      <Route path="/wc/expanded-collections" component={ExpandedCollectionsPage} />
      <Route path="/wc/mini-pdp-modals" component={MiniPdpModalsPage} />
      <Route path="/wc/pdp-mask-safety-disclaimer" component={PdpMaskSafetyDisclaimerPage} />
    </Switch>
  );
}

export const slug = "wc";
